import React, {FunctionComponent, useContext} from 'react';
import "./CommentSection.scss"
import {CommentContext} from "../../context/CommentContext";
import {Comment} from "../../models/comment.model";
import {CommentTile} from "../../components/CommentTile/CommentTile";
import {SectionPreloader} from "../../components/SectionPreloader/SectionPreloader";
import {CommentCreate} from "../../components/CommentCreate/CommentCreate";

export const CommentSection: FunctionComponent = () => {
    const commentContext = useContext(CommentContext);

    //uncommented before we will add permissions for comments
    // useEffect(commentContext.loadComments, [false]);

    const onCreateComment = async (commentText: string) => {
        commentContext.createComment(commentText);
    }

    return (
        <section className='basic-section comment-section'>
            <h3>Comments</h3>

            <CommentCreate onCreateComment={onCreateComment}/>

            {!commentContext.isCommentsLoading
                ? <div className='comments-container'>
                    {commentContext.comments.map((comment: Comment) => {
                        return <CommentTile comment={comment}/>
                    })}
                </div>
                : <SectionPreloader/>}
        </section>
    );
};